import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import hero from "../assets/hero.jpg";

const ValueProposition = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  return (
    <section className="py-20 bg-gradient-to-br from-aquagray to-aquablue relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 z-0">
                <div className="absolute inset-0 bg-gradient-to-br from-aquagreen/20 via-transparent to-blue-900/20" />
                <img
                  src={hero}
                  alt="Système aquaponique"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/80 backdrop-blur-lg" />
            </div>

      <div className="relative max-w-6xl mx-auto px-6">
        <motion.div
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          className="text-center"
        >
          <motion.div
            variants={itemVariants}
            className="bg-white/10 backdrop-blur-sm rounded-3xl p-12 border border-white/20 shadow-2xl max-w-4xl mx-auto"
          >
            <motion.h2
              variants={itemVariants}
              className="text-4xl md:text-6xl font-bold text-aquacream mb-8 leading-tight"
            >
              Produisez j'usqu'à{" "} <span className="text-aquagreen">€100</span> de plantes et{" "}
              <span className="text-aquagray">€50</span> de truite fraîche{" "}
              <span className="text-aquagreen">chaque mois</span>
            </motion.h2>
            
            <motion.p
              variants={itemVariants}
              className="text-2xl text-aquacream/90 mb-12 font-medium"
            >
              — Depuis votre propre jardin.
            </motion.p>

            <motion.div
              variants={itemVariants}
              className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12"
            >
              <div className="text-center p-6 bg-white/10 rounded-2xl backdrop-blur-sm border border-white/20">
                <div className="text-5xl font-bold text-aquagreen mb-2">€150</div>
                <p className="text-aquacream/90 font-medium">plantes & poissons mensuel</p>
              </div>
              <div className="text-center p-6 bg-white/10 rounded-2xl backdrop-blur-sm border border-white/20">
                <div className="text-5xl font-bold text-aquagray mb-2">€20</div>
                <p className="text-aquacream/90 font-medium">Abonnement mensuel</p>
              </div>
              <div className="text-center p-6 bg-white/10 rounded-2xl backdrop-blur-sm border border-white/20">
                <div className="text-5xl font-bold text-aquagreen mb-2">+€1500</div>
                <p className="text-aquacream/90 font-medium">Économies annuelle</p>
              </div>
            </motion.div>

            <motion.div
              variants={itemVariants}
              className="flex flex-col sm:flex-row gap-4 justify-center"
            >
              <motion.a
                href="https://forms.gle/gv7DaeyYDsvayxjXA"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-4 bg-transparent border-2 border-aquagreen text-aquagreen font-bold text-lg rounded-full hover:bg-aquagreen hover:text-aquablue transition-all duration-300"
              >
                Participez à l'aventure
              </motion.a>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default ValueProposition;